import { Outlet, Navigate } from 'react-router-dom';
import { useIsAthenticatedUser } from '../utils/utils';

const PublicRoutes = () => {
  return useIsAthenticatedUser() ? <Navigate to='/' /> : <Outlet />;
};

export default PublicRoutes;
